<template>
  <b-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column label="Destinatários">{{
        props.row.email
      }}</b-table-column>
      <b-table-column label="Tipo" width="50%">{{
        labelType[type][1]
      }}</b-table-column>
      <b-table-column label="Criado em">{{
        props.row.created_at | date
      }}</b-table-column>
      <b-table-column label="Opções">
        <button
          @click="onClickDeleteRecipient(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Excluir'"
          color="danger"
        >
          <b-icon size="is-small" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>
  </b-table>
</template>

<script>
import FormRecipientService from '@/services/form-recipient.service';
import { FormRecipientsTypeLabel } from '@/enums/FormRecipientsEnum';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'form-recipients-type-table',
  mixins: [ToastMixin],
  props: ['type'],
  data: () => {
    return {
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
      labelType: Array.from(FormRecipientsTypeLabel),
    };
  },
  methods: {
    load(type) {
      this.loading = true;
      FormRecipientService.getByType(type, {
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;
          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastfy('Erro ao carregar informações.', 'error'))
        .finally(() => (this.loading = false));
    },
    onClickDeleteRecipient(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Campanha',
        message:
          'Tem certeza que deseja <b>excluir</b> este e-mail? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir e-mail',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteRecipient(id),
      });
    },
    deleteRecipient(id) {
      FormRecipientService.delete(id)
        .then(() => {
          this.toastify('E-mail excluído com sucesso.');
          this.load(this.type);
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir E-mail.',
            'error'
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    if (this.type) this.load(this.type);
  },
};
</script>
